/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: navigation.ts
 🗓️ Created: 2025-01-05
 🧩 Description:
    Navigation store for managing page titles, breadcrumbs,
    and navigation state throughout the platform.

 🔧 Notes:
    - Implements Zustand store for navigation state management
    - Manages current page title and breadcrumb information
    - Provides centralized navigation state control
    - Supports dynamic page title updates
    - Integrates with header component for title display
    - Ensures consistent navigation state across components

 🔁 Last Updated: 2025-01-05 by Rodrigo Cuadra
────────────────────────────────────────────────────────────────*/

import { create } from 'zustand';

interface NavigationState {
  currentPageTitle: string | null;
  setCurrentPageTitle: (title: string | null) => void;
}

export const useNavigationStore = create<NavigationState>((set) => ({
  currentPageTitle: null,
  setCurrentPageTitle: (title) =>
    set((state) =>
      state.currentPageTitle === title ? state : { currentPageTitle: title }
    ),
}));



